import styled from '@emotion/styled'
import { useState } from 'react'
import Accordion from '@components/pages/advantageous/FAQSection/Accordion'
import { useTranslation } from 'react-i18next'
import Head from 'next/head'

type Props = {
  useCaseSlug: string
}

const UseCaseFAQSection = ({ useCaseSlug }: Props) => {
  const [openItem, setOpenItem] = useState<string>('')
  const { t } = useTranslation('useCases')

  const data: { title: string; content: string }[] = t(
    `${useCaseSlug}.faq.items`,
    { returnObjects: true }
  )

  const header = t(`${useCaseSlug}.faq.header`)

  return (
    <Container>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: data.map((item) => ({
                '@type': 'Question',
                name: item.title,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.content,
                },
              })),
            }),
          }}
        />
      </Head>
      <Wrapper>
        <Header>{header}</Header>
        <ContentWrapper>
          {data.map((item) => (
            <Accordion
              title={item.title}
              openItem={openItem}
              setOpenItem={setOpenItem}
              content={item.content}
              key={item.title}
            />
          ))}
        </ContentWrapper>
      </Wrapper>
    </Container>
  )
}

export default UseCaseFAQSection

const Container = styled.div`
  @media (min-width: 640px) {
    min-height: 970px;
    padding: 5rem 0;
  }
  padding: 4rem 0;
  background-color: #e7eaff;
  margin: 8rem 0rem;
  margin-bottom: 4rem;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const Header = styled.div`
  font-family: Sofia Pro;
  font-size: 64px;
  font-weight: 600;
  line-height: 64px;
  text-align: center;
  margin: 0rem 0rem 4rem 0rem;
  @media (min-width: 640px) {
    margin: 0rem 0rem 5rem 0rem;
  }
  @media screen and (max-width: 596px) {
    font-size: 36px;
    line-height: 36px;
  }
`
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  @media screen and (max-width: 1038px) {
    padding: 0 1rem;
  }
`
